import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';
import {GlobalConstants} from 'src/app/global-constants'

@Component({
  selector: 'app-component-testing-reminder-notices',
  templateUrl: './component-testing-reminder-notices.component.html',
  styleUrls: ['./component-testing-reminder-notices.component.scss']
})
export class ComponentTestingReminderNoticesComponent implements OnInit {


  constructor(
    private keycloakService: KeycloakService,
    private appConstants : AppConstants
  ) { }

  userInfo: any;
  async ngOnInit() {
    this.isLoading = true
      const user = this.appConstants.userDetails
      this.userInfo = user
      this.sendReminderNoticesInfo();
  }
  
  sendToken: any = {};
  async getToken() {
    let token
    if (await this.keycloakService.isLoggedIn()) {
      token = await this.keycloakService.getToken();
      this.sendToken = Object.assign({}, {
        token: token
      })
    }
  }

  reminderNoticesInfo: any = {}
  sendReminderNoticesInfo() {
    let details = {
      sprigEndPoint: this.appConstants.endPoints.sprigEndPoint,
      scheduleApplicationID: GlobalConstants.scheduleApplicationID,
      certificatesEndPoint: this.appConstants.endPoints.certificatesEndPoint,
      userInfo: this.userInfo
    }
    this.reminderNoticesInfo = {...{}, ...details}
      this.getToken();
      setTimeout(() => {
        this.getToken();
      }, 1000);
  }

  isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }

  goToQueue(event){
    // if(event && event.detail)
    // this.router.navigate(['/queued-correspondence']);
  }

}
